const config = require("config");

(function () {
  "use strict";

  angular
    .module("alk.marketing")
    .directive("hubspotForm", hubspotForm);

  function hubspotForm() {

    var hubspotFormController = ["$window", function ($window) {

      $window.hbspt.forms.create({
        portalId: config.hubspotPortalId,
        formId: config.hubspotFormId,
        target: "#hubSpotFormDiv",
        css: "" // allow to use custom css style
      });

    }];

    var directive = {
      template: require("./hubspotForm.html"),
      restrict: "E",
      scope: {
      },
      controller: hubspotFormController
    };

    return directive;
  }

})();



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-marketing/hubspotForm.directive.js